import { useUser } from 'builder/hooks/useUser'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { Candidate, selectors } from 'builder/modules/resumeDistribution'

import { useGetRecruitersList } from '../useGetRecruitersList'
import { RecruiterList } from './RecruitersList/RecruitersList'
import * as Styles from './styles'
import { Header } from './Header/Header'
import { SnackBar } from './SnackBar/SnackBar'

interface IProps {
  candidate: Candidate
}

export const Widget = ({ candidate }: IProps) => {
  const user = useUser()
  const { data, isLoading } = useGetRecruitersList()

  const nextDistributionDate = useTypedSelector(selectors.nextDistributionDate)
  const distributedRecruiterCount = data?.pagination.totalRecords || 0

  return (
    <Styles.Container>
      {!isLoading && <SnackBar distributedRecruiterCount={distributedRecruiterCount} />}

      <Styles.HeaderContainer>
        <Header
          candidate={candidate}
          nextDistributionDate={nextDistributionDate}
          distributedRecruiterCount={distributedRecruiterCount}
          isDistributionDatesLoading={isLoading}
        />
      </Styles.HeaderContainer>

      <Styles.ListContainer>
        {!user?.hasPremiumFeatures && <Styles.PremiumContainerBlur />}
        <RecruiterList
          candidate={candidate}
          recruiters={data?.data || []}
          isRecruitersLoading={isLoading}
        />
      </Styles.ListContainer>
    </Styles.Container>
  )
}
